<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch6">
<div class="chapterHead"><p class="centerImage3"><img alt="image" src="images/ch6.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">You back up, heart pounding in fear.</p>
<p class="para" style="text-indent: 5%;">What now? Is Gabe a vampire, too? Did Fifi bite him?</p>
<p class="para" style="text-indent: 5%;">Gabe bursts out laughing. “Ha-ha. Got you good!” he says, doubling over.</p>
<p class="para" style="text-indent: 5%;">“You creep!” you yell.</p>
<p class="para" style="text-indent: 5%;">Gabe laughs again, then tells you the truth. “It was easy,” he says. “I just ran over to the Eyeball Man’s store. I remembered seeing something there called Dog in a Can. So I bought a bunch of them. Sure enough, there were these little packets inside. They said, ‘Danger — Keep Away’ — just like on the blood packet. So I opened one, and it was a dog biscuit. I figured it was worth a try.”</p>
<p class="para" style="text-indent: 5%;">“You mean you gave the biscuits to the vampire dogs, and they changed back?” you gasp. “Excellent!”</p>
<p class="para" style="text-indent: 5%;">Then an idea hits you. A great idea!</p>
<p class="para" style="text-indent: 5%;">“Do you have one of those special dog biscuits left?” you ask.</p>
<p class="para" style="text-indent: 5%;">“Yeah,” Gabe replies. “So what?”</p>
<p class="para" style="text-indent: 5%;">“Give me one,” you say. “I think I want to be a dog for Halloween!”</p>
<p class="paraCenter" style="text-indent: 0%;"><span class="bold"><a href="#/e9780545820660_toc001">THE END</a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch006.vue?0eeb5522